export default {
  body: {
    emptyDataSourceMessage: 'Nessun dato da mostrare',
    addTooltip: 'Aggiungi',
    deleteTooltip: 'Elimina',
    editTooltip: 'Modifica',
    filterRow: {
      filterTooltip: 'Filtra',
    },
    editRow: {
      deleteText: 'Sei sicuro di voler rimuovere questa riga?',
      cancelTooltip: 'Annulla',
      saveTooltip: 'Salva',
    },
  },
  grouping: {
    placeholder: "Trascina un'intestazione qui per raggruppare",
    groupedBy: 'Raggruppato per:',
  },
  header: {
    actions: 'Azioni',
  },
  pagination: {
    firstAriaLabel: 'Prima pagina',
    firstTooltip: 'Prima pagina',
    labelDisplayedRows: '{from}-{to} di {count}',
    labelRowsPerPage: 'Righe per pagina:',
    labelRowsSelect: 'righe',
    lastAriaLabel: 'Ultima pagina',
    lastTooltip: 'Ultima pagina',
    nextAriaLabel: 'Pagina successiva',
    nextTooltip: 'Pagina successiva',
    previousAriaLabel: 'Pagina precedente',
    previousTooltip: 'Pagina precedente',
  },
  toolbar: {
    addRemoveColumns: 'Aggiungi o rimuovi colonne',
    exportAriaLabel: 'Esporta',
    exportName: 'Esporta CSV',
    exportTitle: 'Esporta',
    nRowsSelected: '{0} righe selezionate',
    searchPlaceholder: 'Cerca',
    searchTooltip: 'Cerca',
    showColumnsAriaLabel: 'Mostra colonne',
    showColumnsTitle: 'Mostra colonne',
  },
};
